import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(
    name: string,
    description: string,
    extra: string
) {
    return { name, description, extra };
}

const rows = [
    createData(
        'Propias de Profuturo.', 
        'Permiten la correcta navegación del sitio y brindan acceso a las diversas operaciones que ponemos a su disposición por este medio.',
        'Dichas cookies no contienen información que permita identificarlo como individuo, son propiamente utilizadas con las finalidades ya mencionadas.'),
    createData(
        'Google Analytics.', 
        'Obtienen información sobre la forma en que utiliza el sitio, datos demográficos y de intereses.',
        'Dichas cookies no contienen información que permita identificarlo como individuo, son propiamente utilizadas con las finalidades ya mencionadas.'),
    createData(
        'Redes Sociales.', 
        'Permiten compartir comentarios, calificaciones, páginas, a través de las herramientas de diversas redes sociales.',
        'Dichas cookies no contienen información que permita identificarlo como individuo, son propiamente utilizadas con las finalidades ya mencionadas.'),
];

function BasicTable() {

    return (
        <TableContainer component={Paper} 
            sx={{
                border: '2px solid #477EFD80',
                borderRadius: '20px',
                boxShadow: 'none',
            }}>
            <Table sx={{ borderCollapse: 'collapse', tableLayout: 'fixed' }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                        <TableCell 
                            className='title_table'
                            sx={{ borderBottom: '1px solid #477EFD80' }}>Cookies</TableCell>
                        <TableCell 
                            align="left" 
                            className='title_table'
                            sx={{ borderBottom: '1px solid #477EFD80' }}>Finalidad de Uso</TableCell>
                        <TableCell 
                            align="left" 
                            className='title_table'
                            sx={{ borderBottom: '1px solid #477EFD80' }}>Finalidad de Uso</TableCell>
                        </TableRow>
                    </TableHead>
                <TableBody>
                    {rows.map((row) => (
                    <TableRow
                        key={row.name}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell 
                            className='text_table' 
                            component="th" 
                            scope="row"
                            sx={{ borderBottom: '1px solid #477EFD80' }}>
                        {row.name}
                        </TableCell>
                        <TableCell 
                            className='text_table' 
                            align="right"
                            sx={{ borderBottom: '1px solid #477EFD80' }}>{row.description}
                        </TableCell>
                        <TableCell 
                            className='text_table' 
                            align="right"
                            sx={{ borderBottom: '1px solid #477EFD80' }}
                            dangerouslySetInnerHTML={{ __html: row.extra}}/>
                        {/* </TableCell> */}
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        );
}

const MediosCookies = () => {
    return (
        <main className='container_aviso'>
            <section className='container_cookies'>
                <div className='container_med-cookies'>
                    <p className='subtitle_aviso'>Uso de "cookies" y tecnología</p>
                    <p className='text_general'>
                        El sitio de Profuturo (<span className="correo_span">www.profuturo.mx</span>) utiliza cookies (propias y de terceros), las cuales les permiten navegar y acceder a las diversas facilidades
                        que ponemos a su disposición; permitiéndonos identificar las páginas que más se visitan y a medir la eficacia de nuestras campañas de publicidad, esto
                        nos proporcionan información que utilizamos para mejorar nuestros servicios.<br/><br/>

                        Los tipos de cookies presentes en el sitio de Profuturo son:<br/><br/>
                    </p>
                    <BasicTable /><br />
                    <p className='text_fot_table'>
                        Usted puede restringir, bloquear o borrar las cookies de Profuturo o cualquier otra página web, utilizando su navegador, la manera de hacerlo es diferente de 
                        acuerdo con cada navegador.<br/><br/>
                    </p>

                    <div className='divider'></div><br/>

                    <p className='subtitle_aviso'>Medios por los que se darán a conocer los cambios en el aviso de privacidad</p>
                    <p className='text_general'>
                        El presente aviso de privacidad puede sufrir cambios o actualizaciones derivadas de nuevos requerimientos legales, mejoras en las actividades que realizamos,
                        prácticas de privacidad o cambios en nuestro modelo de negocio. En Profuturo nos comprometemos a notificarle cualquier actualización a través de nuestra 
                        página de internet (<span className="correo_span">www.profuturo.mx</span>).<br/><br/>
                        
                        Para más información ponernos a su disposición los siguientes servicios de atención de la Oficina de Datos Personales: <span className="correo_span">datospersonales@profuturo.com.mx</span><br/><br/>

                        Actualización: Septiembre 2025.
                    </p>
                </div>
            </section>
        </main>
    )
}

export default MediosCookies